export const WITHDRAW = '/withdraw';
export const WITHDRAW_COIN = `${ WITHDRAW }/:code`;
export const WITHDRAW_CONFIRMATION = `${ WITHDRAW }/confirmation/:token`;
